function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* eslint-disable no-empty-function */
import autoBind from 'auto-bind';
import throttle from 'lodash.throttle';
import '../snippets/yotpo-pictures-widget';

var HomepageUGCSection = /*#__PURE__*/function () {
  function HomepageUGCSection(container) {
    _classCallCheck(this, HomepageUGCSection);

    this.$container = $(container);
    this.id = this.$container.data('section-id');
    this.type = this.$container.data('section-type');
    autoBind(this);

    this._init();
  }

  _createClass(HomepageUGCSection, [{
    key: "onUnload",
    value: function onUnload() {}
  }, {
    key: "onSelect",
    value: function onSelect() {}
  }, {
    key: "onDeselect",
    value: function onDeselect() {}
  }, {
    key: "_isVisible",
    value: function _isVisible(ele) {
      // Determine if an element is in the visible viewport
      var _ele$getBoundingClien = ele.getBoundingClientRect(),
          top = _ele$getBoundingClien.top,
          bottom = _ele$getBoundingClien.bottom;

      var vHeight = window.innerHeight || document.documentElement.clientHeight;
      return (top > 0 || bottom > 0) && top < vHeight;
    }
  }, {
    key: "_addClass",
    value: function _addClass(el, cls) {
      if (!el.className.match(new RegExp('(?:^|\\s)' + cls + '(?!\\S)'))) {
        el.className += ' ' + cls;
      }
    }
  }, {
    key: "_delClass",
    value: function _delClass(el, cls) {
      el.className = el.className.replace(new RegExp('(?:^|\\s)' + cls + '(?!\\S)'), '');
    }
  }, {
    key: "_handleScroll",
    value: function _handleScroll() {
      var yotpoGallery = document.querySelectorAll('.yotpo-pictures-widget-lazyload');

      if (!this._isVisible(yotpoGallery[0])) {
        return;
      }

      if (!document.querySelector('div.yotpo-display-wrapper')) {
        return;
      }

      this._addClass(yotpoGallery[0], 'yotpo-pictures-widget');

      this._delClass(yotpoGallery[0], 'yotpo-pictures-widget-lazyload');

      if (typeof window.Yotpo === 'undefined' || typeof window.Yotpo.API === 'undefined' || window.yotpo === 'undefined') {
        console.error('Yotpo API is missing', window.Yotpo, window.yotpo);
      } else {
        var api = new window.Yotpo.API(window.yotpo);
        api.refreshWidgets();
        window.removeEventListener('scroll', this.handleScrollThrottled);
        console.debug('Yotpo Images Widget refreshed!');
      }
    }
  }, {
    key: "_init",
    value: function _init() {
      this.handleScrollThrottled = throttle(this._handleScroll, 250, {
        leading: true
      });
      window.addEventListener('scroll', this.handleScrollThrottled);
    }
  }]);

  return HomepageUGCSection;
}();

export function registerHomepageUGCSection() {
  if (!window.theme && !window.theme.sectionsInstance) {
    throw Error('Expected Sections instance to be initialized and set to window.theme.sectionsInstance!');
  }

  window.theme.sectionsInstance.register('homepageugc', HomepageUGCSection);
}